module.exports = __webpack_public_path__ + "img/collection-engagementRingsExclusive@2x.0fed498.jpg";